module.exports = __webpack_public_path__ + "static/media/data_science.792bd84d.svg";